import React from 'react';
import { LoadingIcon } from 'basis';
import styled from '@emotion/styled';

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 35%;
  font-family: 'Latitude Sans', sans-serif;
  background-color: ${props => props.backgroundColor || '#006aff'};
  &:hover:not(:disabled) {
    background-color: var(--Background-Primary-hover, #6cf898);
  }
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  border: none;
  border-radius: 4px;
  cursor: ${props => (props.disabled || props.loading ? 'not-allowed' : 'pointer')};
  transition: all 0.3s;

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.sm})`} {
        width: 100%;
    }

    `}
`;

export const StartApplicationButton = ({ loading, disabled, children, backgroundColor = false, onSubmit }) => {
  return (
    <StyledButton
      backgroundColor={backgroundColor}
      disabled={disabled}
      loading={loading}
      data-testid="start-application-button"
      onClick={onSubmit}
    >
      {loading ? (
        <LoadingIcon color="white" />
      ) : (
        <b style={{ color: 'var(--Flat-colours-Indigo, var(--Indigo-1000, #0b2374))', fontSize: 16 }}>{children}</b>
      )}
    </StyledButton>
  );
};
